import type { DocumentType } from 'state/__generated__/tadaahAPI';
import { useApiDocumentTypesList } from 'state/__generated__/tadaahAPI';
import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type UseGetDocumentTypesHandler = {
  data: DocumentType[];
  error: string | undefined;
  isLoading: boolean;
};

const useGetDocumentTypes = (): UseGetDocumentTypesHandler => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, error, isLoading } = useApiDocumentTypesList({
    query: {
      enabled: isLoggedIn,
      queryKey: 'document-types',
    },
  });
  return { data: data?.data ?? [], error: error?.message, isLoading };
};

export default useGetDocumentTypes;
